<template>
  <div class="ticket">
    <d-search :searchData="searchData" @searchEvent="searchEvent" @resetEvent="resetEvent" />
    <div class="content">
      <d-lable class="contentTable" :tableData='tableData' :columnData='columnData'>
        <template v-slot:payChannel="{ row }">
          <span>{{ $map.payChannels[row.payChannel] || '其他' }}</span>
        </template>
      </d-lable>
    </div>
    <d-paging :pager="pager" @change="getItemList" />
  </div>
</template>

<script>
import DSearch from "@/components/d-search";
import DLable from "@/components/d-table";
import DPaging from "@/components/d-paging";
import moment from 'moment'
import { filterDayDate, disabledDayDate } from "@/utils/utils";
export default {
  name: "Ticket",
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  components: {
    DSearch,
    DLable,
    DPaging,
  },
  data () {
    return {
      childList: [],
      searchData: {
        searchItem: [
          {
            label: '选择店铺',
            value: 'shopIds',
            type: 'linkageSelect',
            placeholder: '',
            options: [],
            filterable: true,
            optionProps: {
              value: 'id',
              label: 'name',
              children: 'childList'
            }
          },
          {
            label: "充值渠道",
            value: "payChannel",
            type: "commonSelect",
            placeholder: "",
            options: this.$map.getter('payChannels')
          },
          {
            label: "时间范围",
            value: "date",
            type: "scopeDate",
            startPlaceholder: "开始日期",
            endPlaceholder: "结束日期",
            noClear: true,
            options: {
              onPick: filterDayDate.bind(this),
              disabledDate: disabledDayDate.call(this, 365 * 24 * 60 * 60 * 1000)
            }
          },
        ],
        searchBtn: {
          queryBtn: true,
          resetBtn: true,
        },
        params: {
          shopIds: [],
          date: [],
          payChannel: ''
        },
      },
      columnData: [
        { prop: 'tenantName', label: '店铺名称' },
        { prop: 'roomName', label: '水电表名称' },
        { prop: 'payUser', label: '充值人' },
        { prop: 'payChannel', label: '充值渠道', slotProp: true },
        { prop: 'amount', label: '充值金额' },
        { prop: 'insTime', label: '充值时间' },
      ],
      tableData: [],
      maxDate: null,
      minDate: null,
      pager: {
        count: 0,
        page: 1,
        rows: 10,
      },
      isShow: false,
      id: ''
    };
  },
  created () {
    this.setInitDate()
    this.searchEvent()
    this.getShopList()
  },
  methods: {
    setInitDate () {
      const endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
      const startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD')
      this.searchData.params.date = [startDate, endDate]
    },
    searchEvent () {
      this.pager.page = 1
      this.pager.rows = 10
      this.getItemList()
    },

    resetEvent () {
      this.setInitDate()
      this.getItemList()
    },

    findElementById (data = [], targetId) {
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        if (item.id === targetId) {
          return item;
        }
        if (item.childList && item.childList.length > 0) {
          const result = this.findElementById(item.childList, targetId);
          if (result) {
            return result;
          }
        }
      }
      return null;
    },

    setParams () {
      const { date, shopIds, payChannel } = this.searchData.params
      const [startTime, endTime] = date || []
      let currentShop = this.findElementById(this.childList, shopIds[shopIds.length - 1])
      return {
        pageNum: this.pager.page,
        pageSize: this.pager.rows,
        startTime: startTime ? startTime : null,
        endTime: endTime ? endTime : null,
        title: currentShop ? currentShop.shopCode : null,
        payChannel
      }
    },
    getItemList () {
      const data = this.setParams()
      this.$api.merchant.getRechargeRecordListApi(data).then(({ code, data }) => {
        if (code !== 200) return
        this.pager.count = data.total || 0
        this.tableData = data.list
      })
    },
    /**
     * 获取选择店铺列表
     */
    getShopList () {
      this.$api.shopapi.getShopList()
        .then(({ data, code }) => {
          if (code == 200) {
            this.childList = data.childList
            const child = [{
              id: data.id,
              name: data.name,
              childList: data.childList
            }]
            this.searchData.searchItem.forEach(ele => {
              if (ele.type === 'linkageSelect') {
                ele.options = child
              }
            })
          }
        })
    }
  },
};
</script>

<style scoped lang='scss'>
.ticket {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 0 30px 30px;
  margin-top: -20px;
  box-sizing: border-box;
  width: 100%;

  .header {
    position: relative;
    line-height: 28px;
    display: flex;
    justify-content: flex-end;
  }

  .el-table {
    flex: 1;
    overflow-y: auto;
    margin-top: 20px;
  }
}

.d-paging {
  text-align: center;
}
</style>